import { isProductionEnv } from "./helpers";
import i18n from '../i18n';

let $instances = [];
let $counter = 1;

const windowOpts = `height=450,width=768,resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no`;

export const initialize = () => {
    window.addEventListener('message', (event) => {
        const { type, payload, ID } = event.data;
        const instance = $instances.find(i => i.id === ID);
        if (instance) {
            switch (type) {
                case 'READY':
                    instance.connected = true;
                    break;
                case 'END':
                    instance.alive = false;
                    instance.connected = false;
                    if (instance.rootNode) {
                        document.body.removeChild(instance.rootNode);
                    } else {
                        instance.window.close();
                    }
                    break;
            }
            instance.listener(type, payload, ID);
        }
    });
    setInterval(() => {
        $instances.filter(i => !i.connected).forEach(i => {
            dispatch(i.id, 'CONNECT', {
                ID: i.id,
            });
        });
    }, 1000);
};

export const openPopup = (url, listener, windowName = '') => {
    const wnd = window.open(url, windowName, windowOpts);
    const popup = {
        id: $counter++,
        window: wnd,
        url,
        listener,
        alive: true,
        connected: false,
        rootNode: false,
    };
    $instances.push(popup);
    return popup.id;
};

export const openIframe = (url, listener, className = '') => {
    const iframe = document.createElement('iframe');
    iframe.src = url;
    const div = document.createElement('div');
    div.className = className;
    div.append(iframe);
    document.body.append(div);
    const popup = {
        id: $counter++,
        window: iframe.contentWindow,
        url,
        listener,
        alive: true,
        connected: false,
        rootNode: div,
    };
    $instances.push(popup);
    return popup.id;
};

export const dispatch = (id, type, payload) => {
    const instance = $instances.find(i => i.alive && i.id === id);
    if (instance) {
        instance.window.postMessage({
            type,
            payload,
        }, instance.url);
    }
};

export const closeAllInstances = () => {
    $instances.filter(i => i.alive).forEach(i => {
        if (i.rootNode) {
            i.alive = false;
            i.connected = false;
            document.body.removeChild(i.rootNode);
        } else {
            i.alive = false;
            i.connected = false;
            i.window.close();
        }
    })
};

export const getStudioUrl = (width = 1800, height = 277, vlines = '', hlines = '') => {
    const base = isProductionEnv()
    ? 'https://business.pressenger.com/studio/index.html'
    : 'https://test.pressenger.com/studio/index.html';
    //: 'http://localhost:3000/index.html';
    return `${base}?embedded=yes&width=${width || ''}&height=${height || ''}&vlines=${vlines}&hlines=${hlines}&locale=${i18n.locale}`;
};

export const getModNewsUrl = (csrf, mode = 'android', info = undefined) => {
    const base = isProductionEnv()
    ? 'https://business.pressenger.com/news2/index.html'
    : 'https://test.pressenger.com/news2/index.html';
    // : 'http://localhost:3000/index.html';
    return `${base}?embedded=yes&locale=${i18n.locale}&csrf=${csrf}&mode=${mode}${info ? `&info=${info[0]};${info[1]}` : ``}`;
};

export const isAnyStudioOpen = () => {
    return $instances.filter(i => i.alive).length > 0;
};
